import $ from "jquery";
import bdjs from "@bd-core/bdjs";
import bdapi from "@bd-core/bd-api";

export const RedirectPage = () => {
    const isRedirectPage = $("#redirect-page").length > 0;

    if (!isRedirectPage) return;

    const onSumbitTeamCode = async () => {
        const teamCode = $("input[name='team_code']").val();
        const [res, err] = await bdjs.goAsync(bdapi.post("public/join-team", {
            team_code: teamCode,
        }));

        const restData = res?.data || {};

        if (restData?.data?.redirect) {
            bdjs.showLoading();
            window.location.href = restData.data.redirect;
            return;
        }

        if (!restData?.success || err) {
            const errMsg =
                restData?.data?.message ||
                "Something went wrong. Please try again!";
            
            console.error(errMsg);
        }
    };

    // Use a small delay before submit the team code to ensure the page has loaded
    window.onload = function() {
        setTimeout(function() {
            onSumbitTeamCode();
        }, 100);
    };
};
